import { z } from 'zod';
import { api } from 'utils/api';
import {
  DocumentLink,
  IndexedItemRef,
  RecentDocument,
  favoriteDocumentSchema,
  recentDocumentSchema,
} from 'domain/documents/schemas/document';

// Favoris et récents vivent dans le service `discovery`, à côté de la recherche
// (docs/discovery/RESTAPI-DISCOVERY.md §2.2-2.3) : un élément s'y désigne par sa source et son
// identifiant chez cette source, jamais par le seul identifiant.
const BASE = import.meta.env.VITE_DISCOVERY_SERVICE_URL;

const itemPath = ({ source, entityId }: IndexedItemRef) =>
  `${encodeURIComponent(source)}/${encodeURIComponent(entityId)}`;

export const documentService = {
  getFavorites: (): Promise<DocumentLink[]> =>
    api.get<unknown>(BASE, 'favorite/me').then(links => z.array(favoriteDocumentSchema).parse(links)),

  addFavorite: ({ source, entityId }: IndexedItemRef) => api.post<void>(BASE, 'favorite/me', { source, entityId }),

  removeFavorite: (ref: IndexedItemRef) => api.delete<void>(BASE, `favorite/me/${itemPath(ref)}`),

  // Le service trie déjà par consultation décroissante et borne la liste à 50 entrées : retrier ici
  // ne ferait que dupliquer une garantie du contrat.
  getRecents: (): Promise<RecentDocument[]> =>
    api.get<unknown>(BASE, 'recent/me').then(links => z.array(recentDocumentSchema).parse(links)),

  addRecent: ({ source, entityId }: IndexedItemRef) => api.post<void>(BASE, 'recent/me', { source, entityId }),

  removeRecent: (ref: IndexedItemRef) => api.delete<void>(BASE, `recent/me/${itemPath(ref)}`),
};
